/* eslint-disable prefer-template */
/* eslint-disable camelcase */
/* eslint-disable no-loss-of-precision */
export function filterImage(url, side) {
  const isHttpUrl = url && url.indexOf('http') === -1

  if (!isHttpUrl) return url

  if (side) url += `?x-oss-process=image/resize,m_fill,w_${side}`
  return `${process.env.VUE_APP_FILE_URL}?code=${url}`
}

export function formatGender(val) {
  const map = {
    0: '未知',
    1: '男',
    2: '女'
  }

  return map[val] || val
}

export function filterPrice(val) {
  if (!(val % 100)) return parseInt(val / 100, 10)

  return (val / 100).toFixed(val % 10 ? 2 : 1)
}

export function filterDotPrice(val) {
  return (val % 100).toString().padStart(2, '0')
}

export function filterActivtyType(val) {
  if (val === 'GENERAL') return '-'

  const map = {
    HELPCUT: '好友砍价',
    GROUPON: '拼团购',
    LIMITDISCOUNT: '特价促销',
    SECKILL: '限时秒杀'
  }

  return map[val] || val
}

export function filterTimeStyle(val) {
  return `${val.substring(0, 10).replace(/-/g, '.')} ${val.substring(11)}`
}

export function filterTimeStamp(timestamp) {
  const year = timestamp.getFullYear()
  const month = (timestamp.getMonth() + 1).toString().padStart(2, '0')
  const date = timestamp.getDate().toString().padStart(2, '0')
  const hour = timestamp.getHours().toString().padStart(2, '0')
  const minute = timestamp.getMinutes().toString().padStart(2, '0')
  const second = timestamp.getSeconds().toString().padStart(2, '0')

  return filterTimeStyle(`${year}-${month}-${date} ${hour}:${minute}:${second}`)
}

/*
 百度坐标系转腾讯,高德坐标系
*/
export function bMapTransqqMap(lng, lat) {
  if (!lng || !lat)
    return {
      lng: 0,
      lat: 0
    }
  const x_pi = (3.14159265358979324 * 3000.0) / 180.0
  const x = lng - 0.0065
  const y = lat - 0.006
  const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi)
  const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi)
  const lngs = z * Math.cos(theta)
  const lats = z * Math.sin(theta)
  return {
    lng: lngs,
    lat: lats
  }
}

// 腾讯坐标转换成百度坐标
export function qqMapToBMap(lng, lat) {
  if (!lng || !lat) {
    return {
      lng: '',
      lat: ''
    }
  }
  const x_pi = 3.14159265358979324
  const x = parseFloat(lng)
  const y = parseFloat(lat)
  const z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi)
  const theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi)
  const bmlng = (z * Math.cos(theta) + 0.0065).toFixed(5)
  const bmlat = (z * Math.sin(theta) + 0.006).toFixed(5)
  return {
    lng: bmlng,
    lat: bmlat
  }
}

// 时间戳13位
export const formatDate = (time) => {
  // 时间戳转日期
  // eslint-disable-next-line prefer-const
  let date = new Date(time)
  // eslint-disable-next-line prefer-const
  let y = date.getFullYear()
  let MM = date.getMonth() + 1
  MM = MM < 10 ? '0' + MM : MM
  let d = date.getDate()
  d = d < 10 ? '0' + d : d
  // let h = date.getHours()
  // h = h < 10 ? '0' + h : h
  // let m = date.getMinutes()
  // m = m < 10 ? '0' + m : m
  // let s = date.getSeconds()
  // s = s < 10 ? '0' + s : s
  // return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
  return y + '-' + MM + '-' + d
}

// 时间戳13位
export const timeFormate = (time) => {
  if (!time) return ''
  // 时间戳转日期
  // eslint-disable-next-line prefer-const
  let date = new Date(time)
  // eslint-disable-next-line prefer-const
  let y = date.getFullYear()
  let MM = date.getMonth() + 1
  MM = MM < 10 ? '0' + MM : MM
  let d = date.getDate()
  d = d < 10 ? '0' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let m = date.getMinutes()
  m = m < 10 ? '0' + m : m
  let s = date.getSeconds()
  s = s < 10 ? '0' + s : s
  return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
}
